(function() {
  const labelSelector = 'data-custom-select-label';
  const filterSelector = 'data-custom-select-opts';
  const filterLabel = document.querySelector(`[${labelSelector}]`);

  const sortBy = (url, sectionId) => {
    fetch(`${url}&section_id=${sectionId}`)
      .then(res => res.text())
      .then(responseText => {
        const new_html = new DOMParser()
          .parseFromString(responseText, 'text/html')
      })
  }

  const collectionFilters = (filter) => {
    let items = Array.from(filter.childNodes);

    items.forEach(item => {
      item.addEventListener('click', () => {
        filterLabel.innerHTML = item.innerHTML;
        item.setAttribute('selected', 'selected');
        filter.classList.remove('custom-select--open');
        filterLabel.classList.remove('custom-select-label--open');
        const val = item.getAttribute('data-value');
        window.removeEventListener('click', ()=>{});
        window.location.href = `${window.location.pathname}?sort_by=${val}`
      })
    })
  }

  const setLabel = (filter) => {
    const val = window.location.search.split('=')[1];
    const childs = Array.from(filter.childNodes);
    
    childs.forEach(item => {
        item?.removeAttribute('selected');
        if(val && item.getAttribute('data-value') === val) {
          filterLabel.innerHTML = item.innerHTML;
          item.setAttribute('selected', 'selected');
        } else if(!val) {
          childs[0].setAttribute('selected', 'selected');
        }
      });
  }

  const filterToggle = (filter) => {
    window.addEventListener('click', (e) => {
      if(e.target !== filter 
          && e.target !== filterLabel 
          && e.target !== filterLabel.previousElementSibling) {
        filter.classList.remove('custom-select--open');
        filterLabel.classList.remove('custom-select-label--open');
      }
    })

    filter.classList.toggle('custom-select--open');
    filterLabel.classList.toggle('custom-select-label--open');
    collectionFilters(filter, filterLabel)
  }

  const id = filterLabel.getAttribute(labelSelector);
  const filter = document.querySelector(`[${filterSelector}="${id}"]`);
  const type = filter.getAttribute('data-custom-select')
  // setLabel(filter, filterLabel);
  if(type === 'collection') {
    if(window.location.search === '') {
      filterLabel.classList.add('custom-select-label--first-run');
    }
    filterLabel.addEventListener('click', () => {filterToggle(filter, filterLabel)});
    filterLabel.previousElementSibling
      .addEventListener('click', () => {filterToggle(filter, filterLabel)});
  }

})();